import React from "react";
import { Carousel } from "react-bootstrap";

export default function ImageSlider({ images }) {
  return (
    <Carousel style={{ borderRadius: "10px" }}>
      {images.map((image, index) => (
        <Carousel.Item key={index}>
          <img
            className="d-block w-100"
            src={image.src}
            alt={`Slide ${index}`}
            style={{ objectFit: "cover", borderRadius: "10px", height: "30em", width: "100%" }}
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );
}
